// extracted by mini-css-extract-plugin
export default {"mainComtainer":"TermsAndCondition_mainComtainer__7yRBx","header_main":"TermsAndCondition_header_main__h7c9c","btnDiv":"TermsAndCondition_btnDiv__HzMur"};